module.exports = __webpack_public_path__ + "img/logo_istruct_cuprolli.9cc87404.svg";